import { Skeleton } from "@components/common/skeleton";
import * as S from "../AnalyticsPage.styled";

export const AnalyticsPageSkeleton = () => {
  const backgroundColor = "var(--background-skeleton-0)";
  return (
    <S.Container
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 12,
        height: "calc(100% - 16px)",
        width: "100%",
        overflow: "hidden"
      }}
    >
      {/* filter menu */}
      <S.Content style={{ width: 284, flex: "none", padding: "20px" }}>
        <Skeleton isLoading>
          <div
            className="skeleton"
            style={{
              width: 116,
              height: 20,
              backgroundColor,
              borderRadius: 4
            }}
          />
        </Skeleton>
      </S.Content>
      {/* contents */}
      <S.Content
        style={{ width: "calc(100% - 76px)", height: "100%", padding: "20px" }}
      >
        <Skeleton isLoading>
          <div
            className="skeleton"
            style={{
              width: 116,
              height: 20,
              backgroundColor,
              borderRadius: 4
            }}
          />
          <div
            className="skeleton"
            style={{
              width: 800,
              height: 20,
              backgroundColor,
              borderRadius: 4,
              marginTop: 16,
              marginBottom: 24
            }}
          />
          {/* card */}
          {Array.from({ length: 3 }).map((_, index) => {
            return (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={`skeleton-card-${index}`}
                style={{
                  border: "1px solid var(--hv-options-border-color)",
                  padding: 16,
                  borderRadius: 4,
                  height: 472,
                  boxSizing: "border-box",
                  marginTop: 20
                }}
              >
                <div style={{ display: "flex" }}>
                  <div
                    className="skeleton"
                    style={{
                      width: 20,
                      height: 20,
                      backgroundColor,
                      borderRadius: 4,
                      marginRight: 8
                    }}
                  />
                  <div
                    className="skeleton"
                    style={{
                      width: 245,
                      height: 20,
                      backgroundColor,
                      borderRadius: 4
                    }}
                  />
                </div>
              </div>
            );
          })}
        </Skeleton>
      </S.Content>
    </S.Container>
  );
};
